import moment from "moment";

import { timeframeToRange } from "src/organization/pages/project/environment/metrics/components/Chart/settings";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

export const formatTimeFrame = (timeframe?: TimeFrameType) => {
  const range = timeframeToRange(timeframe);
  const start = moment(range.start);
  const end = moment(range.end);
  const format = "HH:mm";
  const monthDayFormat = format + " MMM D, ";
  const yearFormat = "YYYY";
  const sameDay = start.isSame(end, "day");
  const sameMonth = start.isSame(end, "month");
  const sameYear = start.isSame(end, "year");

  if (sameDay && sameMonth && sameYear) {
    return `${start.format(format)} - ${end.format(
      format + " MMM D, " + yearFormat
    )}`;
  } else if (!sameDay && sameMonth && sameYear) {
    return `${start.format(monthDayFormat)} - ${end.format(
      monthDayFormat + yearFormat
    )}`;
  } else {
    return `${start.format(format)} ${start.format(
      "MMM D, " + yearFormat
    )} - ${end.format(format)} ${end.format("MMM D, " + yearFormat)}`;
  }
};
